import axios from 'axios';
import clients from './clients';
import show from './showOrHidden';
import operator from './operator';
import protocol from './protocol';
import occurence from './ocurrences';
import clientData from './newConnectLine';
import Swal from 'sweetalert2';
import moment from 'moment';

const { io } = require("socket.io-client");
var socket = io(`${location.protocol}//${location.hostname}:4000`);

const dateTimeFormat = new Intl.DateTimeFormat('pt-br', { year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric' });

const getMenssagensChat = (inputConversa) => {
	let key = Object.keys(inputConversa)[0];
	inputConversa = inputConversa[key];

	const ultimaMsg = inputConversa.msgs[inputConversa.msgs.length - 1];
	const resp = {
		operador: inputConversa.operador_id,
		avatar: inputConversa.avatar,
		nome: inputConversa.nome,
		notify: inputConversa.notify,
		fila: inputConversa.queue,
		time: '',
		text_prev: '',
		key: key,
		cpd: inputConversa?.cpd,
		created_at: inputConversa.created_at,
		protocol: inputConversa.protocol,
		phone: inputConversa.phone,
		first: inputConversa.first,
		channel: inputConversa.channel,
		id_crm: inputConversa.id_crm,
	};

	if (ultimaMsg) {
		if (/^\d+$/.test(ultimaMsg.data)) {
			ultimaMsg.data = dateTimeFormat.format(ultimaMsg.data);
		}
		resp.time = ultimaMsg.data;
		resp.text_prev = ultimaMsg.mensagem.slice(0, 40) + (ultimaMsg.mensagem.length > 39 ? '…' : '');

		//Mensagem de notificacao
		if (resp.text_prev.substring(0, 4) == '<img') {
			resp.text_prev = '<span title="Foto"><div style="float: left; padding: 0px 5px 0px 0px;"><span data-icon="status"><svg viewBox="0 0 16 20" width="16" height="20" class=""><path fill="currentColor" d="M13.822 4.668H7.14l-1.068-1.09a1.068 1.068 0 0 0-.663-.278H3.531c-.214 0-.51.128-.656.285L1.276 5.296c-.146.157-.266.46-.266.675v1.06l-.001.003v6.983c0 .646.524 1.17 1.17 1.17h11.643a1.17 1.17 0 0 0 1.17-1.17v-8.18a1.17 1.17 0 0 0-1.17-1.169zm-5.982 8.63a3.395 3.395 0 1 1 0-6.79 3.395 3.395 0 0 1 0 6.79zm0-5.787a2.392 2.392 0 1 0 0 4.784 2.392 2.392 0 0 0 0-4.784z"></path></svg></span></div><span style="float: left;">Foto</span></span>';
		}
		else if (resp.text_prev.substring(0, 4) == '<aud') {
			resp.text_prev = '<span title="Áudio"><div style="float: left; padding: 0px 5px 0px 0px;"><span data-icon="status"><svg viewBox="0 0 12 20" width="12" height="20" class=""><path fill="currentColor" d="M6 11.745a2 2 0 0 0 2-2V4.941a2 2 0 0 0-4 0v4.803a2 2 0 0 0 2 2.001zm3.495-2.001c0 1.927-1.568 3.495-3.495 3.495s-3.495-1.568-3.495-3.495H1.11c0 2.458 1.828 4.477 4.192 4.819v2.495h1.395v-2.495c2.364-.342 4.193-2.362 4.193-4.82H9.495v.001z"></path></svg></span></div><span style="float: left;">Áudio</span></span>';
		}
		else if (resp.text_prev.substring(0, 4) == '<vid') {
			resp.text_prev = '<span title="Vídeo"><div style="float: left; padding: 0px 5px 0px 0px;"><span data-icon="status"><svg viewBox="0 0 16 20" width="16" height="20" class=""><path fill="currentColor" d="m15.243 5.868-3.48 3.091v-2.27c0-.657-.532-1.189-1.189-1.189H1.945c-.657 0-1.189.532-1.189 1.189v7.138c0 .657.532 1.189 1.189 1.189h8.629c.657 0 1.189-.532 1.189-1.189v-2.299l3.48 3.09v-8.75z"></path></svg></span></div><span style="float: left;">Vídeo</span></span>';
		}
		else if (resp.text_prev.substring(0, 4) == '<a h') {
			resp.text_prev = '<span title="Anexo"><div style="float: left; padding: 0px 5px 0px 0px;"><span data-icon="status"><svg viewBox="0 0 13 20" width="13" height="20" class=""><path fill="currentColor" d="M10.2 3H2.5C1.7 3 1 3.7 1 4.5v10.1c0 .7.7 1.4 1.5 1.4h7.7c.8 0 1.5-.7 1.5-1.5v-10C11.6 3.7 11 3 10.2 3zm-2.6 9.7H3.5v-1.3h4.1v1.3zM9.3 10H3.5V8.7h5.8V10zm0-2.7H3.5V6h5.8v1.3z"></path></svg></span></div><span style="float: left;">Anexo</span></span>';
		}
	}

	return resp;
}

const sumTotalNaoLido = (conversas) => {
	return conversas.reduce((t, inputConversa) => {
		let key = Object.keys(inputConversa)[0];
		inputConversa = inputConversa[key]
		return t + inputConversa.notify
	}, 0)
}

const meuAvatar = '/imgs/icons/person.svg';
const wppAvatar = '/imgs/default-profile.png';

const state = {
	conversasChat: [],
	conversasWhatsapp: [],
	conversasFacebook: [],
	conversasInstagram: [],
	currentConversa: 'conversasChat',
	currentConversaIndex: '',
	token: '',
	protocol: '',
	curConversaCNPJ: '',
	logchat: [],
	userRealtime: '',
	userRealtimeData: '',
	userPhotoOperator: '',
	logInfo: [],
	totalMyQueue: 0,
	options: [],
	transfData: [],
	dataLog: [],
	msgQueue: [],
	msgVisualizada: false,
	unreadMessages: [],
}

const formatData = (data) => {
	let dt = data.trim().split(" ");
	return {
		'data': dt[0],
		'hora': dt[1]
	}
}

const getters = {
	gettransfData: state => state.transfData,
	getOptions: state => state.options,
	getCurrentMensagens: (state) => {
		if (!state.currentConversa) {
			return [];
		}
		const currentChat = state[state.currentConversa];
		return currentChat.map(getMenssagensChat);

	},
	getCurrentConversa: (state) => {
		if (!state.currentConversa || state.currentConversaIndex === null) {
			return [];
		}

		let index = state.conversasChat.findIndex(el => Object.keys(el) == state.token);
		let currentConversa = state[state.currentConversa][index];

		let key = Object.keys(currentConversa)[0];
		currentConversa = currentConversa[key];

		const objReturn = [];
		const dataCheck = [];

		currentConversa.msgs.forEach(function (msg) {
			let sepData = formatData(msg.data);

			let exibirData = '';
			if (!dataCheck.includes(sepData.data)) {
				dataCheck.push(sepData.data);
				exibirData = sepData.data;
			}

			const obj = {
				isProprio: msg.type,
				exibirData: exibirData,
				data: sepData.data,
				hora: sepData.hora,
				legend: msg.legend,
				mensagem: msg.mensagem,
				avatar: msg.isProprio ? meuAvatar : currentConversa.avatar,
				idOperador: currentConversa.operador,
				channel: currentConversa.channel,
				phone: currentConversa.phone,
				id_crm: currentConversa.id_crm,
				instagram_id: currentConversa?.instagram_id || null,
			}
			objReturn.push(obj);
		});

		return objReturn;
	},
	getTemCurrentConversa: (state) => {
		if (!state.token) return null;
		let index = state.conversasChat.findIndex(el => Object.keys(el) == state.token);
		if (state.currentConversa && state.currentConversaIndex !== null && state[state.currentConversa][index]) {
			return state[state.currentConversa][index];
		}
	},
	getTotalChatQueue: (state) => state.conversasChat.length,
	getTotalNaoLidoWhatsapp: (state) => sumTotalNaoLido(state.conversasWhatsapp),
	getTotalNaoLidoFacebook: (state) => sumTotalNaoLido(state.conversasFacebook),
	getTotalNaoLidoInstagram: (state) => sumTotalNaoLido(state.conversasInstagram),
	getCurrentConversaIndex: state => state.currentConversaIndex,
	getTokenChatClient: state => state.token,
	getlogchat: state => state.logchat,
	getUserRealtime: state => state.userRealtime,
	getUserRealtimeData: state => state.userRealtimeData,
	getUserPhotoOperator: state => state.userPhotoOperator,
	getlogInfo: state => state.logInfo,
	getTotalMyQueue: state => state.totalMyQueue,
	getTotalInQueue: state => state.conversasChat.length,
	getConversasChat: state => state.conversasChat,
	getItemMessage: state => {
		if (!state.currentConversa) {
			return [];
		}
		const currentChat = state[state.currentConversa];
		let newMessages = [];
		currentChat.forEach(elemento => {
			const [key, value] = Object.entries(elemento)[0];
			const lastMessageIndex = value.msgs.length - 1;
			const lastMessage = value.msgs[lastMessageIndex];

			if (lastMessage) {
				const now = new Date();
				const [datePart, timePart] = lastMessage.data.split(' ');
				const [day, month, year] = datePart.split('/');
				const [hour, minute, second] = timePart.split(':');
				const messageDate = new Date(year, month - 1, day, hour, minute, second);

				const timeDifference = Math.abs(now - messageDate); // Diferença de tempo em milissegundos
				const timeDifferenceInSeconds = timeDifference / 1000;

				const isSameDate = timeDifferenceInSeconds <= 5 // Margem de erro de 5 segundos

				if (value.operador !== '' && isSameDate) {
					newMessages.push({ ...value, msgVisualizada: false });
				}
			}
		});
		return newMessages;
	},
	getMessagesNotRead: state => {
		if (!state.currentConversa) {
			return [];
		}
		const currentChat = state[state.currentConversa];
		let newMessages = [];
		currentChat.forEach(elemento => {
			const [key, value] = Object.entries(elemento)[0];
			let receivedMsgs = value.msgs.filter(msg => msg.status === "RECEIVED");
			if (receivedMsgs.length > 0) {
				newMessages.push({
					...value,
					msgs: receivedMsgs
				});
			}
		});
		return newMessages;
	},
	getDataLog: state => state.dataLog,
	getMsgQueue: state => state.msgQueue,
	getUnreadMessages: state => state.unreadMessages,
}

const mutations = {
	addMensagemCurrentConversa(state, { isProprio, data, mensagem, file, filename, type, channel }) {
		if (!state.currentConversa || state.currentConversaIndex === null) {
			return;
		}

		const obj = {
			token: state.token,
			msg: mensagem,
			exten: user.getId(),
			channel
		}

		if (file && filename && type) {
			obj.file = file;
			obj.filename = filename;
			obj.type = type;
		}

		socket.emit('sendMessageOthers', obj);
	},

	queueMessage(state, { isProprio, data, mensagem, file, filename, type }) {
		if (!state.currentConversa || state.currentConversaIndex === null) {
			return;
		}

		const obj = {
			token: state.token,
			msg: mensagem,
			exten: user.getId(),
		}

		if (file && filename && type) {
			obj.file = file;
			obj.filename = filename;
			obj.filetype = type;
		}

		socket.emit('queueMessage', obj);
	},

	changeMsgQueue(state, queue) {
		const payload = {
			token: state.token,
			queue
		}
		socket.emit('updateMsgQueue', payload);
	},

	sendMsgQueue(state) {
		socket.emit('sendMsgQueue', state.token);
		state.msgQueue = [];
	},

	addTemplateMessage(state, templateData) {
		if (!state.currentConversa || state.currentConversaIndex === null) {
			return;
		}

		const obj = {
			token: state.token,
			msg: templateData.msg,
			template_name: templateData.name,
			language: templateData.language,
			parameters: templateData.parameters,
			exten: user.getId(),
			headerMedia: templateData.headerMedia,
			mediaType: templateData.mediaType,
			base64: templateData.base64,
			filename: templateData.filename
		}

		socket.emit('sendTemplateMessage', obj);
	},

	endCurrentConversa(state, arrayData) {
		occurence.actions.fetchOcurrences(this, []);
		const conversa = state[state.currentConversa][state.currentConversaIndex][state.token];
		const channel = conversa.channel;


		socket.emit('disconnectClient', {
			exten: user.getId(),
			token: state.token,
		});

		if (operator.state.myChannel == '') {
			protocol.actions.fetchProtocol(this);
			clients.state.client = [];
		}

		if (this.getters.getProtocol.protocol == state.protocol) {
			state.protocol = '';
		}

		clientData.mutations.delDataConnectLine();
	},

	endCurrentConversaTemplate(state, arrayData) {
		occurence.actions.fetchOcurrences(this, []);
		var uniqueid = state.token;
		let test = state.token.match(/^WPP_(.+)/);
		if (test) {
			var currTime = Date.now();
			uniqueid = `${state.token}-${currTime}`;
		}

		let obj = {
			at_user_id: operator.state.id,
			ticket: state.ticket,
			protocol: state.protocol,
			cpf_cnpj: state.curConversaCNPJ,
			uniqueid: uniqueid,
			type: state.currentConversa,
			created_at: new Date().toISOString().replace(/T/, ' ').replace(/\..+/, ''),
			updated_at: new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '')
		}

		socket.emit('disconnectClientTemplate', {
			exten: user.getId(),
			token: state.token,
			atendimento: obj
		});

		if (operator.state.myChannel == '') {
			protocol.actions.fetchProtocol(this);
			clients.state.client = [];
		}

		if (this.getters.getProtocol.protocol == state.protocol) {
			state.protocol = '';
		}

		clientData.mutations.delDataConnectLine();
	},

	async setCurrentConversa(state, index) {

		const raw = index.replace(/\D/g, '');
		// let num = raw.replace(/^55/g, '');
		clients.actions.chooseClientPhone(this, raw);
		clients.actions.fetchClientsOP(this, raw);

		if (!index) index = state.token;
		if (!state.currentConversa) return null;

		const arrIndex = state[state.currentConversa].findIndex(el => Object.keys(el)[0] == index);

		if (!state[state.currentConversa][arrIndex]) return null;

		await actions.markAsRead(state, index);

		if (state[state.currentConversa][arrIndex][index].client_id !== state.token && state.token !== "") {
			let arrIndex2 = state[state.currentConversa].findIndex(el => Object.keys(el)[0] == state.token);
			state[state.currentConversa][arrIndex2][state.token].notify = 0;
			state[state.currentConversa][arrIndex2][state.token].msgVisualizada = false;

		}

		state.token = index;
		state.currentConversaIndex = arrIndex;
		state[state.currentConversa][arrIndex][state.token].notify = 0;
		state[state.currentConversa][arrIndex][index].msgVisualizada = true;
		const clientInfo = state[state.currentConversa][arrIndex][index];
		let objInfo = {}

		if (clientInfo) {
			const cpd = clientInfo?.cpd ?? clientInfo?.cod_cliente;
			const cpf_cnpj = clientInfo.cpf_cnpj ?? clientInfo.num_cnpj_cpf;
			objInfo = {
				protocol: clientInfo.protocol,
				phone: clientInfo.client_id,
				instagram_id: clientInfo?.instagram_id || null,
				name: clientInfo.client,
				queue: clientInfo.queue,
				channel: clientInfo.channel,
				sessionDate: clientInfo.sessionDate,
				email_cliente: clientInfo?.email_cliente,
				empresa: clientInfo?.empresa,
				cpf_cnpj: cpf_cnpj,
				dat_emissao: clientInfo?.dat_emissao,
				num_pedido: clientInfo?.num_pedido,
				cpd: cpd,
			}
		}

		const { data: currentLog } = await axios.get(`/getAttLog?key=${index}`);
		if (currentLog && currentLog.client_id) state.dataLog = currentLog;

		socket.emit('setClientToMe', {
			token: state.token,
			exten: user.getId(),
			name: user.getName(),
			channel: clientInfo.channel
		});

		Swal.fire({
			text: "Carregando mensagens. Por favor, aguarde...",
			showConfirmButton: false,
			html: `<div><i class="fas fa-spinner fa-pulse"></i><br><span><b>Carregando mensagens</b> <br>Por favor, aguarde...</span></div>`
		});

		const chatMessages = await axios.get('/getMsgsFromRedis', { params: { key: index } })
			.then(({ data }) => {
				Swal.close();
				if (data) return Object.values(data);
				return [];
			}).catch((err) => {
				console.error(err);
				Swal.close();
				return [];
			});

		state.conversasChat[arrIndex][index]['msgs'] = chatMessages;
		state.conversasChat[arrIndex][index]['capture'] = true;

		await clientData.mutations.setChatData(objInfo);
	},

	transfCurrentConversa(state, newQueue, channel) {
		socket.emit('transfClient', {
			client: state.token ? state.token : newQueue.client,
			origin: newQueue.origin,
			destination: newQueue.destination,
			type: newQueue.type,
			realtime: newQueue.realtime,
			channel
		});

		clientData.mutations.delDataConnectLine();
	},

	transfProcess(state) {
		socket.emit('showmeQueueOptionsOperator', {});
	},

	setLogChat: (state, logs) => (state.logchat = logs),
	setLogInfo: (state, logs) => (state.logInfo = logs),

	setUserRealtime: (state, logs) => (state.userRealtime = logs),
	setUserRealtimeData: (state, logs) => (state.userRealtimeData = logs),

	setPhotoOperator: (state, img) => (state.userPhotoOperator = img),

	async listenSessionEvents(state) {
		socket.on("sessionExpired", (log) => {
			if (log.client_id === state.dataLog.client_id) {
				state.dataLog = log;
			}
		});
		socket.on("sessionRenew", (log) => {
			if (log.client_id === state.dataLog.client_id) {
				state.dataLog = log;
			}
		});
	},

	async listenMsgQueue(state) {
		socket.on('msgQueueChanged', async () => {
			if (!state.token) return;
			const { data } = await axios.get(`/getMsgQueue?client=${state.token}`);
			state.msgQueue = data.length ? data : [];
		});
	},

	async listenFailedTemplate(state) {
		socket.on('failedTemplate', async (client) => {
			Swal.fire({
				title: `Conversa finalizada - Falha no envio do template para ${client}`,
				type: "error",
				toast: true,
				timer: 5000,
				showConfirmButton: false,
				position: 'top-end'
			});
		});
	},

	setUnreadMessages: (state, messages) => (state.unreadMessages = messages),
}

const actions = {

	async joinQueue(operator, data) {
		socket.on('connect', () => {
			show.actions.setisReconnect(false);
		});

		const rec = (data == 'reconnect') ? true : false;
		const exten = user.getId();
		const queues = user.getChatQueues();
		const id = operator.rootState.operator.id;
		state.unreadMessages = {}
		await operator.dispatch('fetchUnreadMessages');

		socket.emit('join', { exten, id, queues, rec });
	},

	async leaveQueue(operator, id) {
		const queues = user.getChatQueues()
		state.currentConversaIndex = ''
		state.token = ''
		socket.emit('leave', { id, queues });
	},

	async newEntry({ getters }) {
		socket.on('feedbackStartChat', msg => {
			Swal.fire({
				title: "Não é possível abrir conversa",
				html: msg,
				type: 'info',
				confirmButtonText: "Ok"
			});
		});

		socket.on('newEntry', async (data) => {
			const tempIndex = Object.keys(data)
			let key = Object.keys(data)[0];
			let found = state.conversasChat.findIndex(el => Object.keys(el) == key);
			const unreadMessages = getters.getUnreadMessages

			if (!Object.keys(unreadMessages).includes(key)) {
				state.unreadMessages[key] = 1;
			} else if (!data[key].join) {
				if (data[key].msgs?.length === 1 && (!['operator', 'sistema'].includes(data[key].msgs[0].type))) {
					state.unreadMessages[key] += 1;
				}
			}

			if (state.currentConversaIndex !== found) {
			}

			if (found == -1) {
				data[key]['nome'] = data[key]['client'];
				data[key]['avatar'] = data[key]['avatar'] ?? wppAvatar
				data[key]['notify'] = data[key].msgs.length;
				data[key]['capture'] = false

				state.conversasChat.push(data);

				return;
			}

			if (data[key].operador == user.getId()) {
				state.conversasChat[found][key] = {
					...state.conversasChat[found][key],
					...data[key],
					msgs: state.conversasChat[found][key]?.msgs || []
				};
			}

			let msgs = state.conversasChat[found][key].msgs

			const lastMsgId = msgs[msgs.length - 1].mensagem + 'T' + moment(msgs[msgs.length - 1].data).unix();
			const newMsgId = data[key].msgs[0].mensagem + 'T' + moment(data[key].msgs[0].data).unix();

			if (data[key].msgs.length === 1) {
				if (lastMsgId !== newMsgId) {
					msgs.push(data[key].msgs[0])
				}
			} else {
				msgs = data[key].msgs
			}

			data[key]['nome'] = data[key]['client'];
			data[key]['avatar'] = data[key]['avatar'] ?? wppAvatar
		});
	},

	async removeClient(data) {
		socket.on('removeClient', (token) => {
			let index = state.conversasChat.findIndex(el => Object.keys(el) == token);
			if (index > -1) {
				try {
					if (operator.state.myChannel == '') {
						if (this.getters.getAllOcorrence.length && state.conversasChat[index][state.token]) {
							if (state.conversasChat[index][state.token].nome == this.getters.getAllOcorrence[0].cpf_cnpj) {
								clients.state.client = [];
							}
						}
					}
				} catch (err) {
					clients.state.client = [];
				}
				Vue.delete(state.conversasChat, index);
				if (state.currentConversaIndex === index) {
					state.currentConversaIndex = '';
					state.token = '';
					clients.actions.chooseClientPhone(this, '');
					clientData.mutations.delDataConnectLine();
				}
			}
		});
	},

	async findLogById(state, id) {
		socket.emit('getlog', id);
	},

	async receivelog(state) {
		socket.on('sendlog', data => {
			data[0].meuAvatar = meuAvatar
			state.state.logchat = data[0];
		});
	},

	async changeclientname(state) {
		if (operator.state.myChannel == '') {
			socket.emit('changeClientName', {
				cnpj: clients.state.client.cpf_cnpj,
				token: state.state.token,
				exten: user.getId()
			});
		}
	},

	async checkTotalQUeues(state) {
		const queues = user.getChatQueues();
		const exten = user.getId();

		socket.emit('checkTotalQUeues', {
			queue: queues,
			exten: exten
		});
	},

	async totalMyQueue(state) {
		socket.on('totalMyQueue', total => {
			this.totalMyQueue = total
		});
	},

	async transferOptions(state) {
		socket.on('transferOptions', (queues, operators) => {
			let options = {
				'operators': operators,
				'queues': queues
			}

			state.state.transfData = options;
		});
	},

	async operatorInUse(state) {
		socket.on('operatorInUse', () => {

			Swal.fire({
				title: "Ramal em uso!",
				text: 'Este ramal já foi esta sendo utilizado por outro usuário',
				type: 'info',
				confirmButtonText: "Ok"
			}).then(data => {
				window.location.href = '/';
			});
		});

		socket.on('clientExpirado', () => {
			Swal.fire({
				title: "Sessão do cliente expirou",
				text: 'O cliente já desconectou da sessão ',
				type: 'info',
				confirmButtonText: "Ok"
			});
		})
	},

	async startConversation({ commit, state }, cliente) {
		try {
			socket.emit('startNewChat', {
				phone: cliente.phone,
				operador: user.getId(),
				operator_name: user.getName()
			});

			const index = state.conversasChat.findIndex(conversa =>
				Object.keys(conversa)[0] === cliente.phone
			);

			commit('setCurrentConversa', cliente.phone);
		} catch (error) {
			console.error("Erro ao iniciar conversa:", error);
		}
	}
	,

	async disconnect(state) {
		socket.on('disconnect', msg => {
			socket.removeAllListeners();

			socket = io(`${location.protocol}//${location.hostname}:4000`)
			show.actions.setisReconnect(true);
			actions.joinQueue(state, 'reconnect', 'disconnect');
			actions.newEntry();
			actions.removeClient(state);
			actions.disconnect(state);
			actions.operatorInUse();

			// Log conversa
			actions.receivelog(state);

			// Action transferencia
			actions.totalMyQueue(state);
			actions.transferOptions(state);
		});
	},

	sendCampaign(state, obj) {
		socket.emit('startCampaing', obj);
	},

	async sendAudio(state, obj) {
		try {
			if (!obj.blob) {
				console.error("Nenhum áudio disponível para envio.");
				return;
			}

			if (!state.state.token) {
				console.error("Token de estado não definido. Não é possível enviar o áudio.");
				return;
			}

			const timestamp = Date.now();
			const audioName = `audio_${state.state.token}_${timestamp}.wav`;

			const arrayBuffer = await obj.blob.arrayBuffer();

			socket.emit('blobAudio', {
				blob: new Uint8Array(arrayBuffer),
				token: state.state.token,
				name: audioName,
				channel: obj.channel
			});
		} catch (error) {
			console.error("Erro ao enviar o áudio:", error);
		}
	},

	async fetchUnreadMessages({ commit }) {
		try {
			commit('setUnreadMessages', {});
			const { data } = await axios.get(`/getUnreadMsgsAmount`); // Aguarda a resposta corretamente
			commit('setUnreadMessages', data);
		} catch (error) {
			console.error("Erro ao obter mensagens não lidas:", error);
		}
	},

	async markAsRead({ commit }, key) {
		try {
			socket.emit('updateMessageToRead', { key });
			if (state.unreadMessages[key]) {
				state.unreadMessages[key] = 0;
			}
		} catch (error) {
			console.error("Erro ao marcar mensagem como lida:", error);
		}
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}